// ============================================================================
// dataEvents.ts — ЛОКАЛЬНАЯ шина «данные изменились» (same-session).
// Серверные события (data.*/task.*) — основной канал, но при обрывах потока
// (watchdog/offline) списки не обновляются. После ЛЮБОЙ успешной записи форма
// эмитит это событие; списки (динамические списки, виджеты рабочих столов)
// подписываются и перезагружаются — БЕЗ перезахода в форму.
// ============================================================================

import { useEffect } from 'react';

export type DataAction = 'created' | 'updated' | 'deleted';

export interface DataChangedDetail {
  /** Физическая таблица изменённых данных (напр. tasks_by_orders) */
  table: string;
  entityType?: string;
  entityCode?: string;
  action?: DataAction;
}

const EVENT = 'hydra:data-changed';

export function emitDataChanged(detail: DataChangedDetail): void {
  try {
    window.dispatchEvent(new CustomEvent<DataChangedDetail>(EVENT, { detail }));
  } catch {
    // окружение без window (SSR/тесты) — событие не требуется
  }
}

export function onDataChanged(handler: (d: DataChangedDetail) => void): () => void {
  const fn = (e: Event) => handler((e as CustomEvent<DataChangedDetail>).detail);
  window.addEventListener(EVENT, fn);
  return () => window.removeEventListener(EVENT, fn);
}

/**
 * Хук: перезагружать данные при локальном событии изменения одной из таблиц.
 * Использование в списках/виджетах: useDataRefresh(['tasks_by_orders'], load).
 */
export function useDataRefresh(tables: string[], reload: () => void): void {
  const key = tables.join(',');
  useEffect(() => onDataChanged((d) => {
    if (!key || key.split(',').includes(d.table)) reload();
  }), [key, reload]);
}
